import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/event_clients`, {params: {...filter}})
  },

  indexByEvent({event_id, filter}) {
    return Http.get(`/events/${event_id}/event_clients`, {params: {...filter}})
  },


  create(event_client){
    return Http.post(`/event_clients`, {event_client: {
      ...event_client,
    }})
  },

  update(event_client){
    return Http.put(`/event_clients/${event_client.id}`, {
      event_client: {
        ...event_client,
      },
    });
  },

  show(id) {
    return Http.get(`/event_clients/${id}`);
  },

  delete(id){
    return Http.delete(`/event_clients/${id}`)
  }

}